<h2 mat-dialog-title class="dialog-title">الملاحظات</h2>

<mat-dialog-content class="dialog-content" dir="rtl">
  <table mat-table [dataSource]="notes" class="mat-elevation-z2 notes-table">
    <ng-container matColumnDef="noteText">
      <th mat-header-cell *matHeaderCellDef class="note-text">
        <span class="note-label">الملاحظة</span>
        <span class="note-count">{{ notes.length }}</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="note-content">
          {{ element.noteText }}
          <div class="date-separator"></div>
          <span class="last-modified">آخر تعديل: {{ element.lastModifiedDate | date: 'short' }}</span>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- Add Note Textarea -->
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button mat-dialog-close color="warn">إغلاق</button>
</mat-dialog-actions>
